import { render, staticRenderFns } from "./PmtaEmailTestForm.vue?vue&type=template&id=043974f4&scoped=true"
import script from "./PmtaEmailTestForm.vue?vue&type=script&lang=js"
export * from "./PmtaEmailTestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043974f4",
  null
  
)

export default component.exports